// Module
var code = "<react-component name=\"SmsReplies\"></react-component>\n";
// Exports
module.exports = code;